import { render } from "./modalePathology.vue?vue&type=template&id=ffa8346a"
import script from "./modalePathology.vue?vue&type=script&lang=js"
export * from "./modalePathology.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__